import { ListChart, ListChartProps } from '../../../../renderers/list-chart/list-chart.component';
import { PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST_CHART_DEFINITION } from './pudo-transaction-volume-by-sender-list-chart.definition';
import { PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST_CHART_MOCK_DATA } from './pudo-transaction-volume-by-sender-list-chart.mock';

export const PudoTransactionVolumeBySenderListChart = (props: ListChartProps) => <ListChart {...props} />;

PudoTransactionVolumeBySenderListChart.definition = PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST_CHART_DEFINITION;
PudoTransactionVolumeBySenderListChart.mockData = PUDO_TRANSACTION_VOLUME_BY_SENDER_LIST_CHART_MOCK_DATA;
